<template>
  <div class="view-freebies py-5">
    <div class="container py-5">
      <h1>Conteúdo aberto</h1>
      <div class="subtitle">Aulas disponibilizadas para consulta.</div>

      <action-dispatcher
        action="courses/getFreebies"
        ref="actionDispatcher"
        :parameters="parameters"
      >
        <div class="row">
          <div
            v-for="(lesson, index) in freebies"
            :key="index"
            class="col-lg-3 col-md-6 py-2"
          >
            <lesson-img
              :lesson="lesson"
              route="free-lesson"
              :route-params="lesson"
            />
          </div>
        </div>
      </action-dispatcher>

      <pagination
        class="pt-5"
        :count="count"
        :page="page"
        :limit="parameters.limit"
        @paginate="paginate"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/mixins/Pagination";
import { mapState } from "vuex";

export default {
  mixins: [Pagination],
  data() {
    return {
      perPage: 20
    };
  },
  computed: {
    ...mapState("courses", ["freebies", "count"])
  },
  methods: {
    reload() {
      this.$refs.actionDispatcher.dispatch();
    }
  }
};
</script>

<style lang="scss" scoped>
.view-freebies {
  h1 {
    margin-bottom: 0;
  }

  .subtitle {
    font-size: 16px;
    line-height: 24px;
    color: #979797;
    margin-bottom: 52px;
  }
}
</style>
